import { useHandleResponse } from '@/utils/useHandleResponse';
import { useMutation } from '@tanstack/react-query';
import { App, AutoComplete, Button, Col, Divider, Form, Input, Row, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField, updateProps } from '../../../contextRedux/TimeKeeperDevice/TimeKeeperDeviceModel';
import TimeKeeperDeviceService from '../../../services/timeKeeperDevice/TimeKeeperDeviceService';
import { RootState } from '../../../store';
import useWindowSize from '../../../utils/useWindowSize';

const { Option } = Select;

const TimeKeeperEmployerForm: FC<any> = () => {
  const [form] = useForm();
  const { message } = App.useApp();
  const handleResponse = useHandleResponse();
  const dispatch = useDispatch();
  const width = useWindowSize();

  const timeKeeperSystemTypes = useSelector((state: RootState) => state.store.timeKeeperSystem.data || []);
  const timeKeeperDeviceType = useSelector((state: RootState) => state.models.timeKeeperDevice);

  const initialValues = {
    id: useSelector((state: RootState) => state?.models?.timeKeeperDevice?.id) ?? '',
    systemTypeId: useSelector((state: RootState) => state?.models?.timeKeeperDevice?.timeKeeperSystemTypeId) ?? '',
    name: useSelector((state: RootState) => state?.models?.timeKeeperDevice?.name) ?? '',
    channel: useSelector((state: RootState) => state?.models?.timeKeeperDevice?.channel) ?? '',
    type: useSelector((state: RootState) => state?.models?.timeKeeperDevice?.type) ?? '',
  };

  const handleSelectTimeKeeperSystem = (value: string) => {
    const systemType = timeKeeperSystemTypes?.find((sc) => sc.name === value);
    const fieldsValue = {
      ...form.getFieldsValue(true),
      systemTypeId: systemType?.id,
      systemType: systemType,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'timeKeeperSystemTypeId', value: systemType.id }));
    dispatch(updateField({ field: 'timeKeeperSystemType', value: systemType }));
  };

  const onSaveTimeKeeperDevice = async () => {
    saveDeviceType(timeKeeperDeviceType);
  };

  const { mutate: saveDeviceType, isPending: _isSavingDevice } = useMutation({
    mutationFn: (formData: any) => TimeKeeperDeviceService.upsert(timeKeeperDeviceType.id, formData),
    onSuccess: (data: any) => {
      if (data) {
        handleResponse(data, data?.response?.name);
        dispatch(updateProps({ field: 'isModalVisible', value: false }));
        dispatch(updateProps({ field: 'refresh', value: !timeKeeperDeviceType.props.refresh }));
      }
    },
    onError: (error: any) => {
      message.error(error.message);
    },
  });

  const handleFilter = (inputValue: string, option: any) => {
    return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1;
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  useEffect(() => {
    form.setFieldsValue(timeKeeperDeviceType);
  }, [timeKeeperDeviceType]);

  return (
    <Form
      form={form}
      name='timeKeeperDeviceForm'
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      onFinish={onSaveTimeKeeperDevice}
      layout='vertical'
    >
      <Divider />
      <Row gutter={[16, 16]} className='row'>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item
            label='Tip de sistem'
            name={['timeKeeperSystemType', 'name']}
            rules={[{ required: true, message: 'Introdu tipul de sistem!' }]}
          >
            <AutoComplete onSelect={handleSelectTimeKeeperSystem} filterOption={handleFilter}>
              {timeKeeperSystemTypes?.map((item) => (
                <Option key={item.id} value={item.name}>
                  {item.name}
                </Option>
              ))}
            </AutoComplete>
          </Form.Item>
        </Col>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Denumire' name='name' rules={[{ required: true, message: 'Introdu denumire!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Canal' name='channel' rules={[{ required: true, message: 'Introdu channel!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Type' name='type' rules={[{ required: true, message: 'Introdu type!' }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button type='primary' htmlType='submit'>
          Finalizare
        </Button>
      </Form.Item>
    </Form>
  );
};

export default TimeKeeperEmployerForm;
